import React from 'react';
import ReactTable, { Column } from 'react-table';
import { PortalViewModel } from 'stageclip-common';
import { faPencilAlt, faTrash, faSyncAlt } from '@fortawesome/free-solid-svg-icons';

import { PortalsTableProps } from '../PortalsPage.types';

import Button from 'components/buttons/button';
import { NextButton, PreviousButton } from 'components/table/buttons';
import styles from 'components/events/eventsTable.module.scss';
import tableStyles from 'components/table/appTable.module.scss';
import portalsTableStyles from './PortalsTable.module.scss';

export const PortalsTable = ({ portalsList, loading, onRowClick, onDelete, onClearPortalCache }: PortalsTableProps) => {
  const columns: Column[] = [
    {
      Header: 'Client Name',
      accessor: ({ clientName }: PortalViewModel) => clientName,
      id: 'clientName',
    },
    {
      Header: 'Institution Name',
      accessor: ({ institutionName }: PortalViewModel) => institutionName,
      id: 'institutionName',
    },
    {
      Header: 'Account Name',
      accessor: ({ accountName }: PortalViewModel) => accountName,
      id: 'accountName',
    },
    {
      Header: 'Clip Site URL',
      accessor: ({ domain }: PortalViewModel) => (
        <a
          href={`${process.env.REACT_APP_PORTALS_PROTOCOL}://${domain}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={e => e.stopPropagation()}
        >
          {`${process.env.REACT_APP_PORTALS_PROTOCOL}://${domain}`}
        </a>
      ),
      id: 'domain',
    },
    {
      Header: 'Actions',
      Cell: ({ original: { domain, id: portalId } }) => (
        <>
          <Button text="Edit" icon={faPencilAlt} allCapitals slimButton />
          <Button
            text="Delete"
            icon={faTrash}
            allCapitals
            slimButton
            onClick={e => {
              e.stopPropagation();
              onDelete({ domain, portalId });
            }}
          />
          <Button
            text="Clear cache"
            icon={faSyncAlt}
            allCapitals
            slimButton
            onClick={e => {
              e.stopPropagation();
              onClearPortalCache({ domain });
            }}
          />
        </>
      ),
      className: styles.actions,
      id: 'actions',
      width: 350,
    },
  ];

  return (
    <ReactTable
      loading={loading}
      columns={columns}
      className={tableStyles.appTable}
      noDataText="No matching clip sites."
      data={portalsList || []}
      minRows={0}
      defaultPageSize={10}
      defaultSorted={[{ id: 'clientName', desc: false }]}
      NextComponent={NextButton}
      PreviousComponent={PreviousButton}
      getTrProps={(state: any, row: { original: PortalViewModel }) => ({
        onClick: () => onRowClick(row.original),
        className: portalsTableStyles.row,
      })}
    />
  );
};
